import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Form from './Form';
import DatePicker from './DatePicker';
import Select from './Select';
import YesOrNo from './YesOrNo';
import InputMask from 'react-input-mask';
import CheckBox from './CheckBox';
import PasswordStrength from './PasswordStrength';
import OptionRadio from './OptionRadio';

const Input = memo(({ label, type, name, value, onChange, options, helperMessage, mask, placeholder, isLoading, maxDate, className, ...rest }) => {
  
  const renderInput = () => {
    switch(type){
      case 'option_radio':
        return (
          <OptionRadio 
            options={options}
            name={name}
            onChange={onChange}
            value={value}
            {...rest}
          />
        )
      case 'checkbox':
        return (
          <CheckBox 
            name={name}
            onChange={onChange}
            value={value}
            {...rest}
          />
        )
      case 'yes_or_no':
        return (
          <YesOrNo 
            name={name}
            onChange={onChange}
            value={value}
            {...rest}
          />
        )
      case 'select':
        return (
          <Select 
            isLoading={isLoading}
            placeholder={placeholder}
            name={name}
            onChange={onChange}
            value={value}
            options={options}
            {...rest}
            
          />
        )
      case 'date':
        return (
          <DatePicker 
            placeholderText={placeholder}
            name={name}
            onChange={onChange}
            value={value}
            maxDate={maxDate}
            {...rest}
          />
        )
      case 'mask':
        return (
          <InputMask 
            placeholder={placeholder}
            mask={mask}
            maskChar={' '}
            name={name}
            onChange={onChange}
            value={value}
            {...rest}
          />
        )
      case 'password':
        return (
          <input
            autoComplete={false}
            type="password"
            placeholder={placeholder}
            name={name}
            onChange={onChange}
            value={value}
            {...rest}
          />
        )
      case 'password_strength':
          return (
            <PasswordStrength
              placeholderText={placeholder}
              name={name}
              onChange={onChange}
              value={value}
              {...rest}
            />
          )
      default:
        return (
          <input
            type="text"
            placeholder={placeholder}
            name={name}
            onChange={onChange}
            value={value}
            {...rest}
          />
        )
    }
  }

  return (
    <Form.InputGroup className={className} label={label} helperMessage={helperMessage && helperMessage(name)}>
      {renderInput()}
    </Form.InputGroup>
  )
})

Input.defaultProps = {
  type: 'text',
  label: null,
  placeholder: '',
  mask: '',
  helperMessage: undefined,
  isLoading: false,
  className: ''
}

Input.propTypes = {
  type: PropTypes.oneOf(['text', 'mask', 'date', 'select', 'yes_or_no', 'checkbox', 'password', 'password_strength', 'option_radio']),  
  placeholder: PropTypes.string,  
  label: PropTypes.string, 
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.instanceOf(Function).isRequired,
  helperMessage: PropTypes.instanceOf(Function),
  mask: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]),
  isLoading: PropTypes.bool,
  className: PropTypes.string
}

export default Input